module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0026.png.aaeca41c.jpg";